import { useContext, useEffect, useState } from 'react'
import { authContext } from 'contexts/AuthContext'
import { navAdminList } from '_nav'

const useFilteredMenu = () => {
  const { auth } = useContext(authContext)
  const [permission, setPermission] = useState(null)
  const [role, setRole] = useState(null)
  const [filteredMenus, setFilteredMenus] = useState()

  useEffect(() => {
    setPermission(auth?.data?.staff?.permissions?.map(({ id }) => id))
    setRole(auth?.data?.staff?.roles?.map(({ id }) => id))
  }, [auth])

  // Helper function to check if item should be shown
  const shouldShowItem = (item) => {
    // If requireRole is true, check for roles first
    if (item.requireRole) {
      // User must have roles to proceed - if they do, show the item regardless of permissions
      return role && role.length > 0
    }
    // requireRole is false, directly check permissionId
    if (item.permissionId) {
      return permission?.includes(item.permissionId)
    }
    // No role or permission requirements
    return true
  }

  useEffect(() => {
    setFilteredMenus(
      navAdminList
        .map((item) => {
          if (shouldShowItem(item)) {
            if (item?.items) {
              return {
                ...item,
                items: item?.items.filter(shouldShowItem),
              }
            }
            return item
          }
          return undefined
        })
        .filter((item) => item !== undefined)
        .map((item) => {
          if (item?.items && item?.items?.length === 0) {
            const { items, ...rest } = item
            return rest
          }
          return item
        })
    )
  }, [permission, role])

  return { filteredMenus }
}

export default useFilteredMenu
